import React from "react";
import { Link } from "react-router-dom/cjs/react-router-dom.min";
import { MONTHS, LOGIN_LINK, SIGNUP_LINK, MEMBERSHIP, CRYPTO_SECRET_KEY } from "./constants/constants";
import { CUSTOMCOLORCSS } from "./constants/customCssContant";
import validator from "validator";
import { DUMMY_LETTERS } from "./constants/defaultData";
import CryptoJS from "crypto-js";
import initialData from "./initial-data";

export const scroll2Id = (id, delay = 0) => (
    setTimeout(
        () =>
            document.getElementById(id)?.scrollIntoView({ behavior: "smooth", block: "center", inline: "nearest" }),
        delay
    )
);

export const formatDate = raw => {
  if (typeof raw !== 'string' || !raw || !raw.trim()) {
    return null;
  }
  
  try {
    let d = null, m, y;
    if (/^\s*\d{4}/.test(raw.trim())) {
      m = 'January';
      y = raw.trim();
    } else {
      const parts = raw.split(' ');
      if (parts.length < 2) {
        console.warn('formatDate: Invalid date format, expected "Month Year"', raw);
        return null;
      }
      [m, y] = parts;
    }
    
    const mm = MONTHS.indexOf(m) + 1;
    
    // Validate month and year
    if (mm === 0 || !y || isNaN(parseInt(y))) {
      console.warn('formatDate: Invalid month or year', { month: m, year: y, raw });
      return null;
    }
    
    if (raw.length) {
      d = new Date(`${y}-${mm.toString().length == 1 ? '0'.concat(mm) : mm}-02`);
      
      // Check if date is valid
      if (isNaN(d.getTime())) {
        console.warn('formatDate: Invalid date created', raw);
        return null;
      }
    }
    
    return d;
  } catch (error) {
    console.error('formatDate: Error parsing date', { raw, error: error.message });
    return null;
  }
}

export const rbDate2String = (m, y) => `${MONTHS[m]} ${y}`

export const rbFullDateFormat = (d) => {
  const dd = new Date(d)
  const m = dd.getMonth()
  return `${MONTHS[m]} ${dd.getDate()}, ${dd.getFullYear()}`
}

export const expertiseLabel = (n) => {
  const l = ['nope', 'Beginner', 'Amateur','Competent','Proficient','Expert']
  return n ? l[n] : 'Not rated'
}

export const removeBodyScroll = (toggleScroll) => {
  const bodyTag = document.getElementsByTagName('body');
  if(bodyTag[0]){
    if(toggleScroll){
      bodyTag[0].classList.add('remove-scroll')
    } else {
      bodyTag[0].classList.remove('remove-scroll')
    }
  }
}

export const ucfirst = (word) => {
  const capitalized = word.charAt(0).toUpperCase() + word.slice(1);
  return capitalized;
}

export const getAlphabets = (c) => {
  let Alpha = ['a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k'];
  let result = [];
  if (c.length) {
    var code = c.slice(1);
    for (let i = 0; i < code.length; i++) {
      result[i] = (/^\d+$/.test(code[i]) ? Alpha[parseInt(code[i])] : code[i]);
    }
  }
  return result.join('');
}
export const getCustomTemplateClass = (custom_template_color, obj) => {
  let cssClass = '';

  if (custom_template_color && (typeof obj == 'object' && obj !== undefined)) {
    cssClass = getAlphabets(custom_template_color) + getCombinedCssClass(obj);
  } else if (custom_template_color) {
    cssClass = getAlphabets(custom_template_color)
  } else if (typeof obj == 'object' && obj !== undefined) {
    cssClass = getCombinedCssClass(obj);
  }
  return cssClass;
}

export const getCombinedCssClass = (_obj) => {
  let c = '';
  Object.keys(_obj).forEach((key) => {
    c = c + (_obj[key].textColor && getAlphabets(_obj[key].textColor));
  });
  return c;
}

export const convert2rgba = (hex, alpha) => {
  // Ensure the hex value starts with a '#' and remove it
  hex = hex.startsWith("#") ? hex.slice(1) : hex;
  // Parse the hex values for Red, Green, Blue components
  var r = parseInt(hex.substring(0, 2), 16);
  var g = parseInt(hex.substring(2, 4), 16);
  var b = parseInt(hex.substring(4, 6), 16);
  // Check if alpha is provided, otherwise default to 1.0
  alpha = alpha || 1.0;

  // Validate alpha value
  alpha = Math.min(1, Math.max(0, alpha));

  // Construct the RGBA string
  var rgba = "rgba(" + r + ", " + g + ", " + b + ", " + alpha + ")";

  return rgba;
}

export const applyCustomCSS = (tplname, custom_template_color, obj) => {
  let customCss;
  let m1;
  let m2;
  let m3;
  let finalCss = '';
  var auxilary;
  let css = CUSTOMCOLORCSS[tplname];
  let cssClass = getCustomTemplateClass(custom_template_color, obj);

  if ((custom_template_color && custom_template_color.length) && typeof obj == 'object') {
    m1 = replaceContentColors(css, /\$#CUSCOLPI/g, custom_template_color);
    let rgbaColor = convert2rgba(custom_template_color, 0.5);
    m1 = replaceContentColors(m1, /\$#BGACUSCOLPI/g, rgbaColor);

    if (obj.headingStyle.textColor == '') {
      if (tplname === 'template-sixteen-v2') { // Removed template-twenty-three
        m2 = replaceContentColors(m1, /\$#OTHCFSC/g, '');
      } else {
        m2 = replaceContentColors(m1, /\$#OTHCFSC/g, custom_template_color);
      }
    } else {
      m2 = replaceContentColors(m1, /\$#OTHCFSC/g, obj.headingStyle.textColor);
    }
    m3 = replaceContentColors(m2, /\$#SUBHECCL/g, obj.subHeadingStyle.textColor);
    finalCss = replaceContentColors(m3, /\$#CUSTXTCOL/g, obj.textStyle.textColor);
  }
  else if (!custom_template_color && typeof obj == 'object') {
    m1 = replaceContentColors(css, /\$#OTHCFSC/g, obj.headingStyle.textColor);
    m2 = replaceContentColors(m1, /\$#SUBHECCL/g, obj.subHeadingStyle.textColor);
    finalCss = replaceContentColors(m2, /\$#CUSTXTCOL/g, obj.textStyle.textColor);
  }
  else if ((custom_template_color && custom_template_color.length) && typeof obj === 'string') {
    m1 = replaceContentColors(css, /\$#CUSCOLPI/g, custom_template_color);
    let rgbaColor = convert2rgba(custom_template_color, 0.5);
    m1 = replaceContentColors(m1, /\$#BGACUSCOLPI/g, rgbaColor);
    if (obj == '') {
      if (tplname === 'template-sixteen-v2') { // Removed template-twenty-three
        finalCss = replaceContentColors(m1, /\$#OTHCFSC/g, '');
      } else {
        finalCss = replaceContentColors(m1, /\$#OTHCFSC/g, custom_template_color);
      }
    } else {
    finalCss = replaceContentColors(m1, /\$#OTHCFSC/g, obj);
    }
  }
  auxilary = finalCss.replace(/custom-color-variant/g, cssClass);
  return auxilary;
}

const replaceContentColors = (cssBlock, token, cssrule) => {
  return cssBlock?.replace(token, cssrule);
}

export const stripTags = (s, tags=[]) => {
  if(typeof s === 'string')  
  {
    if(tags.length){
      tags.forEach((v) => {
        // s = s.replace(v, "")
        s = s.replace(new RegExp(`<${v}>`, 'g'), "").replace(new RegExp(`</${v}>`,'g'), "")
      })
      // s = s.replace("<>", "").replace("</>", "")
      // s = s.replace("&lt;&gt;", "").replace("&lt;/&gt;", "")
    }else s = s.replace(/(<([^>]+)>)/gi, "");
  }
  return s;
}

export const convertMonthName = (monthName) => {
  const monthsName = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
  const getMonthCode = monthName.split(' ');
  if(monthName.includes(getMonthCode[0])){
    for(let i = 0; i < monthsName.length; i++){
      if(monthsName[i] == getMonthCode[0]){
          return `0${i+1}/${getMonthCode[1]}`;
      }
    }
  } else {
    return monthName;
  }
 
}

export const formatAddress = (address, city, state, country, postcode, excludeaddressline = false) => {
  let ad = ''
  // Address will execute when <br> tag is not inserted after address
  if(address !== '' && !excludeaddressline) ad = address;
  // This script will execute if city is not empty
  if(city !== '') ad = ( ad !== '' ? `${ad} ${city}` : city);
  // This script will execute if state is not empty
  if(state !== '') ad = ( ad !== '' ? `${ad} ${state}` : state);
  // This script will execute if country is not empty
  if(country !== '') ad = ( ad !== '' ? `${ad} ${country}` : country);
  // This script will execute if zip code is not empty
  if(postcode !== '') ad = (ad !== '' && country == '' ? /* If country is blank */ `${ad} ${postcode}` : `${ad} ${postcode}`);
  return ad;
}

export const validatePassword = (password) => {
  const strongPassParams = {
      minLength: 8, 
      minLowercase: 1,
      minUppercase: 1, 
      minNumbers: 1, 
      minSymbols: 1
  };
  if(!validator.isStrongPassword(password, strongPassParams))
      return false;
  else if(password.includes(' '))
    return false;
  else 
      return true;
}

export const rotateQuickTipsPopup = () => {
  let quickTipsBtn = document.getElementById('quick-tips-btn');
  console.log(quickTipsBtn);
}

export const ucFirstWordOfSentence = (sentence) => {
  const words = sentence.split(" ");
  for (let i = 0; i < words.length; i++) {
      if(i == 0){
        words[i] = words[i][0].toUpperCase() + words[i].substr(1);
        break;
      }else{
        continue;
      }
  }
  return words.join(" ");
}
export const URLink = ({url, TXT_SIZE = 35}) => url != undefined && <a href={
    /^(https?:)?\/\//.test(url) ?
      url :
      `\\\\${url}`}
      target="_blank">
     {url.replace(/^(https?:)?\/\//, '').substring(0,TXT_SIZE)}
    {url.replace(/^(https?:)?\/\//, '').length > TXT_SIZE ? '...': '' }
  </a>

export const validateEmail = (email) => {
  let emailRegex = /(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/;
  if (emailRegex.test(email))
    return true;
  else
    return false;
}

export const squareBracketTextColor = (text, color) => {
  const newText = text.replace(/\[/g, '[<span style="color: ' + color + ';">').replace(/\]/g, '</span>]');
  return newText;
}

export const getExcerpt = (s, start = 0, length = 200) => {
  return `<p>${stripTags(s).substr(start, length)}...</p>`;
}

export const setSleep = (ms) => {
  return new Promise(resolve => setTimeout(resolve, ms));
}

export const encryptNumber = (num) => {
  return (num <= 0 ? '' : encryptNumber(Math.floor(((num * 999)/100) / 26)) + String.fromCharCode(((num * 999)/100)  % 26 + 65));
}

export const decryptNumber = (str) => {
  return (str.toUpperCase().split("").reduce((acc, val) => acc * 26 + val.charCodeAt(0) - 64, 0));
}

export const pageBounces = () => {
  if(window.location.pathname.startsWith(LOGIN_LINK)){
      ga4Track('app_login_page_bounces', 'RB App', 'Login Page Bounces');
  }else if(window.location.pathname.startsWith(SIGNUP_LINK)){
      ga4Track('app_register_page_bounces', 'RB App', 'Register Page Bounces');
  }else if(window.location.pathname.startsWith(MEMBERSHIP)){
      ga4Track('app_registered_user_membership_bounce', 'RB App', 'Membership Page Bounces');
  }
}
export const IconFillReview = ({rating}) => (
  <div className="rating-star color-star">
    {[1,2,3,4,5].map(i => <span className={ rating >= i ? "icon-fill-rating" : "icon-blank-rating" } key={i} ></span>)}
  </div>)
export const CircleFillReview = ({rating}) => (
  <div className="circle-area">
    {[1,2,3,4,5].map(i => <span className={ rating >= i ? "rating-circle fill-circle" : "rating-circle" }  key={i}></span>)}
  </div>)

export const getDateTime = () => {
  const date = new Date();
  return (date.toLocaleDateString('en-US') + ' ' + date.toLocaleTimeString('en-US'));
}

export const getDateForDisplay = (dt) => {
  //Check date includes time or not
  return (((/([0-9]+(\/[0-9]+)+).*([0-9]+(:[0-9]+)+).*[A-Za-z]+/i).test(dt) ? dt.split(" ")[0] : dt));
}

export const getExpirationTime = (sec) => {
  let now = new Date();
  let time = now.getTime();
  let expireTime = time + 1000*parseInt(sec);
  now.setTime(expireTime);
  return now;
}
export const setBodyHeight = () => {
  const body = document.querySelector('body');
  if (body) {
    body.style.height == '' || body.style.height == 'auto' ? body.style.height = '100%' : body.style.height = 'auto';
  }
}
export const calculatePercentage = (percentAmount, totalAmount) => {
  percentAmount = typeof percentAmount == 'undefined' ? 0 : parseFloat(percentAmount);
  totalAmount = typeof totalAmount == 'undefined' ? 0 : parseFloat(totalAmount);
  const percentage = ((percentAmount/totalAmount) * 100).toFixed(2);
  return percentage;
}
export const ScalingResizeHack = () => (<div style={{ width: '2px', height: `${Math.random() * 10}px` }}></div>);

export const getPlanStartDateString = (planStartTime) => {
  const addZeroPadding = (number) => {
      return `${number}`.padStart(2,'0');
  }
  const expiry_date = new Date();
  expiry_date.setTime(parseInt(planStartTime) * 1000);
  return addZeroPadding(expiry_date.getMonth() + 1) + "/" +  addZeroPadding(expiry_date.getDate()) + "/" + expiry_date.getFullYear();
}

export const getResumeName = (resume) => {
  let resumeName = '';
  if (typeof resume == 'undefined' 
      || resume == null 
      || resume == '' 
      || Object.keys(resume).length == 0) return resumeName;
  const fullname = (
      resume?.heading?.fname != ""
          ? resume?.heading?.fname +
          (
              resume?.heading?.lname != ""
                  ? "_" + resume?.heading?.lname
                  : ''
          )
          : "Resume_Draft"
  );
  resumeName = (
      (resume.hasOwnProperty('resume_name')
          && resume.resume_name != '')
          ? resume.resume_name
          : fullname.replace(/\s/g, "_")
  );
  return resumeName;
}

export const getLetterName = (letter) => {
  let name = '';
  if (typeof letter == 'undefined' 
      || letter == null 
      || letter == '' 
      || Object.keys(letter).length == 0) return name;
  const fullname = (
    letter.from?.fname.length ? letter.from?.fname : "Letter_Draft"
  );
  name = (
      (letter.hasOwnProperty('letter_name')
          && letter.letter_name != '')
          ? letter.letter_name
          : fullname.replace(/\s/g, "_")
  );
  return name;
}

export const range = (start, end, length = end - start + 1) => {
  return Array.from({ length }, (_, i) => start + i)
}

export const formatDateHelper = (raw, start = true) => {
  if(raw.trim().length == 0) return raw
  let d = null, m, y
  if (/^\s*\d{4}$/.test(raw.trim())) {
    m = (start ? 'January' : 'December')
    y = raw.trim()
  } else {
    const d2 = raw.split(' ').filter(v => v != '')
    m = d2[0], y = d2[1]
    m = (m.trim() == '' || m.trim() == 'undefined' 
    ? (start ? 'January' : 'December') 
    : m)
  }
  raw.length && (d = `${m} ${y}`)
  return d
}

export const encryptData = (text) => {
  const data = CryptoJS.AES.encrypt(
    JSON.stringify(text),
    CRYPTO_SECRET_KEY
  ).toString()
  return data
};

export const decryptData = (text) => {
  const bytes = CryptoJS.AES.decrypt(text, CRYPTO_SECRET_KEY)
  const data = JSON.parse(bytes.toString(CryptoJS.enc.Utf8))
  return data
};

export const urlWithProtocol = (url) => {
  if(url.trim() == '') return
  return (!/^[a-zA-Z]+:\/\//.test(url) ? `//${url}` : url)
}
export const buttonTextTransition = (label, transite_label, updateLableCallback) => {
  updateLableCallback(transite_label);
  setTimeout(() => {
    updateLableCallback(label)
  }, 2000);

}
export const matchParentClass = (target, className, depth = 3 ) => { 
  if(!depth) return false
  if(target?.classList && target.classList.contains(className) )
    return true
  else{
    return matchParentClass(target.parentElement, className, depth - 1)
  }
}

const isRestrictedUrl = () => {
  let pathname = window.location.pathname;
  const urls = [
    '/create-resume/?$',
    '/choose-template/?$',
    '/create-resume/?$',
    '/editor/additional-sections/?$',
    '/editor/summary-tips/?$',
    '/editor/summary/?$',
    '/templates/?$',
    '/editor/allinone/?$',
    '/r/.+',
    '/rlink/.+'
  ];
  const urlstring = `^(${urls.join('|')})`
  return new RegExp(urlstring).test(pathname)
}

export const showDummyCertificate = (resume) => {
  /*Return true if certificate block is not added in resume 
  template for certain pages and incomplete resumes else false.*/
  let response = false;
  if(!isRestrictedUrl() && !resume?.enabled_tabs.includes('completed') && !resume.hasOwnProperty('certifications')){
    response = true;
  } 
  return response;  
}
export function stringElipse(str, maxLength) {
  const hasSpecialCharacters = /[_\-\s]/.test(str);
  if (hasSpecialCharacters) {
    if (str.length > maxLength) {
        return str.slice(0, maxLength).trim() + '...';
    }
}
return str;
}

export function circleColor(scorePoint) {
  const colors = [
    '#a31f23', '#a92c23', '#ae3624', '#b24025', '#b74b26', '#bc5426', '#c05f28',
    '#c56d27', '#ca7f27', '#cf9125', '#d4a223', '#d8b224', '#dec521', '#d1c526',
    '#c2c129', '#acbc2e', '#9bb733', '#87b239', '#72ab3f', '#5fa744'
  ];
  const pathColor = (
    typeof scorePoint === 'undefined'
      ? '#815600' // Default color for undefined scorePoint
      : (
          scorePoint === 0
            ? '#a31f23' // Red color for scorePoint equal to 0
            : (
                scorePoint != null
                  ? colors[Math.ceil(scorePoint / 5) - 1]
                  : '#a31f23'
              )
        )
  );

  return pathColor;
}

export const isLocalStorageAvailable = () => {
  try {
    const testKey = '__localStorage_test__';
    localStorage.setItem(testKey, 'test');
    localStorage.removeItem(testKey);
    return true;
  } catch (e) {
    return false;
  }
}

export const safeGetLocalStorage = (key, defaultValue = null) => {
  try {
    if (!isLocalStorageAvailable()) {
      return defaultValue;
    }
    const item = localStorage.getItem(key);
    return item !== null ? item : defaultValue;
  } catch (error) {
    console.error('Error accessing localStorage:', error);
    return defaultValue;
  }
}

export const safeSetLocalStorage = (key, value) => {
  try {
    if (!isLocalStorageAvailable()) {
      return false;
    }
    localStorage.setItem(key, value);
    return true;
  } catch (error) {
    console.error('Error setting localStorage item:', error);
    return false;
  }
}

export const safeRemoveLocalStorage = (key) => {
  try {
    if (!isLocalStorageAvailable()) {
      return false;
    }
    localStorage.removeItem(key);
    return true;
  } catch (error) {
    console.error('Error removing localStorage item:', error);
    return false;
  }
}

export const updateYearBeforeNewYear = (dayToUpdateYear = 10) => {
  const currentDate = new Date();
  const currentYear = currentDate.getFullYear();

  // Check if it's within the specified days before the new year
  if (
    currentDate.getMonth() === 11 && // December
    currentDate.getDate() >= 31 - dayToUpdateYear
  ) {
    return currentYear + 1; // Next year
  }

  return currentYear; // Current year
};

export const getNameAbbreviation = (fname, lname, defaultAbbr="YN") => {
  const a = fname ? fname.charAt(0) : defaultAbbr[0];
  const b = lname ? lname.charAt(0) : defaultAbbr[1];
  return (a + b);
}

export const cleanString = (str) => {
  // Fix: RESUMEORG-REACT-8A - Handle non-string inputs
  if (str == null) {
    return '';
  }
  // Convert non-strings to strings (handles numbers, objects, arrays)
  if (typeof str !== 'string') {
    str = String(str);
  }
  return str.replace(/\s*([,|])\s*/g, '$1')
    .replace(/undefined/g, '') // remove undefined
    .replace(/^[,|]+|[,|]+$/g, '') // remove trailing seprator
    .replace(/[,|]+/g, (match) => match[match.length - 1])
    .replace(/,+/g, ', ')
    .replace(/\s?\|+\s?/g, ' | ').trim();
}

export const updateUserDbResume = (userDbResume) => {
  // Ensure initialData and resume are available
  const { resume } = initialData || {};
  //console.log('resume: ', resume);
  if (!resume) {
    console.error("Error: Missing resume data");
    return userDbResume; // Return the original object if resume data is missing
  }

  const comparisonData = {
    work_history: {
      name: ['Enter Your Professional Experience', 'Add Your Professional Experience']
    },
    education_history: {
      name: ['List Your Education', 'Add Your Education']
    },
    skills: {
      name: ['Showcase Your Key Skills', 'Add Your Key Skills', 'List Your Key Skills']
    }
  };

  // Create a new object to ensure immutability
  let updatedResume = { ...userDbResume };

  for (let key in updatedResume) {
    if (comparisonData[key]) {
      const { name } = comparisonData[key];

      // If name exists and is included in comparison data, update the value
      if (updatedResume[key]?.name && name.includes(updatedResume[key].name.trim())) {
        updatedResume[key] = { ...updatedResume[key], name: resume[key]?.name || updatedResume[key].name };
      }
    }
  }

  return updatedResume; // Return the updated resume
};

export const sendTrustpilotInvitation = async (invitationData) => {
  try {
      const response = await fetch('/wp-admin/admin-ajax.php', { // WordPress AJAX endpoint
          method: "POST",
          headers: {
              "Content-Type": "application/x-www-form-urlencoded"
          },
          body: new URLSearchParams({
              action: "send_trustpilot_invite",
              email: invitationData.email.trim(),
              name: invitationData.name.trim(),
              referenceId: invitationData.referenceId
          })
      });

      const result = await response.json();

      if (result.success) {
          console.log("Trustpilot invitation sent successfully!", result);
      } else {
          console.error("Error sending Trustpilot invite:", result.data);
      }
  } catch (error) {
      console.error("AJAX error:", error);
  }
};

export const processTrustpilotInvitation = (userData) => {
  if (userData == null) { // Explicitly check for null or undefined
      console.warn("No user data provided for Trustpilot invitation.");
      return;
  }

  try {
      const user = typeof userData === "string" ? JSON.parse(userData) : userData;

      if (user?.email && user?.id) {
          const recipientName = user.firstName && user.lastName
              ? `${user.firstName.trim()} ${user.lastName.trim()}`
              : user.email.trim();

          const invitationData = {
              email: user.email.trim(),
              name: recipientName,
              referenceId: user.id
          };

          sendTrustpilotInvitation(invitationData);
      } else {
          console.warn("Invalid user data format: Missing email or ID.");
      }
  } catch (error) {
      console.error("Error parsing user data:", error);
  }
}

function decodeHtmlEntity(str) {
  const doc = new DOMParser().parseFromString(str, 'text/html');
  return doc.documentElement.textContent;
}

export const formatDateResume = (start_date, end_date, isPresent = false, hyphen="&ndash;") => {
  const hyphenHTMLEntity = decodeHtmlEntity(hyphen)
  // If start_date exists and currently_studying is true, show "start_date - Present"
  if (start_date && isPresent) {
    return `${start_date} ${hyphenHTMLEntity} Present`;
  }

  // If both start_date and end_date exist, show "start_date - end_date"
  if (start_date && end_date) {
    return `${start_date} ${hyphenHTMLEntity} ${end_date}`;
  }

  // If only start_date exists, show "start_date"
  if (start_date) {
    return start_date;
  }

  // If only end_date exists, show "end_date"
  if (end_date) {
    return end_date;
  }

  // If neither exists and currently_studying is true, show "Present"
  if (isPresent) {
    return "Present";
  }

  return ""; // Return empty string if no date or currently_studying
};

export const addUrlProtocol = (url) => {
  if (!url) {
    return '';
  }
  // Check if the URL starts with http:// or https://
  if (!/^https?:\/\//i.test(url)) {
    // If not, prepend the protocol (use 'https' as the default)
    url = 'https://' + url;
  }
  return url;
}
export const insertKeyAtPosition = (obj, newKey, newValue, index) => {
  const entries = Object.entries(obj);
  entries.splice(index, 0, [newKey, newValue]);
  return Object.fromEntries(entries);
}
export const keyCount = (obj) => {
  return Object.entries(obj).length;
}
export const findKeyPosition = (obj, key) => {
  // Fix RESUMEORG-REACT-7Z: Handle undefined/null obj
  if (!obj || typeof obj !== 'object') {
    console.warn('findKeyPosition: obj is null or undefined', { obj, key });
    return -1; // Key not found
  }
  const keys = Object.keys(obj);
  return keys.indexOf(key);
}
// export const removeAllHTMLTags = (html) => {
//   const parser = new DOMParser();
//   const doc = parser.parseFromString(html, 'text/html');
//   return `<p>${doc.body.textContent}</p>` || "";
// };

export const scroll2 = (id) => {
  const targetElement = document.getElementById(id);
  if (targetElement) {
    const rect = targetElement.getBoundingClientRect();
    const elementBottom = rect.bottom;
    // If the bottom of the element is more than 100px below the viewport bottom
    if (elementBottom > window.innerHeight - 200) {
      const scrollToPosition = window.scrollY + (elementBottom - window.innerHeight + 300);
      if (window.innerWidth < 720) {
        targetElement.scrollIntoView({ behavior: 'smooth', block: 'end' });
      } else {
        window.scrollTo({
          top: scrollToPosition,
          behavior: 'smooth'
        });
      }
    }
  }
}
export const removeAllHTMLTags = (html) => {
  const parser = new DOMParser();
  const doc = parser.parseFromString(html, 'text/html');
  return `<p>${doc.body.textContent}</p>` || "";
};
export const blinkIt = (block) => {
  if (!block || !block.style) return;
  // editor apply blue boarder and remove after 2 seconds
  block.style.outline = "2px solid #EBB800";
  block.style.animation = "blink-outline 0.5s steps(1, start) 4";
  // Add the keyframes if not already present
  if (!document.getElementById("blink-outline-style")) {
    const style = document.createElement("style");
    style.id = "blink-outline-style";
    style.innerHTML = `
          @keyframes blink-outline {
              0%, 100% { outline-color: #EBB800; }
              50% { outline-color: transparent; }
          }
      `;
    document.head.appendChild(style);
  }
  setTimeout(() => {
    block.style.outline = "none";
    block.style.animation = 'none';
  }, 2000);
}
export const setQuickHeaderzInex = (togglezIndex) => {
  const quickHeadTag = document.getElementsByClassName('ai-quick-header');
  const bodyTag = document.getElementsByTagName('body');
  const quickEditResume = document.getElementById('quick-edit-resume')

  if (togglezIndex) {
    quickHeadTag[0]?.classList.add('change-z-index');
    bodyTag[0]?.classList.add('remove-scroll');
    quickEditResume?.classList.add('change-overflow');
  } else {
    quickHeadTag[0]?.classList.remove('change-z-index');
    bodyTag[0]?.classList.remove('remove-scroll');
    quickEditResume?.classList.remove('change-overflow');
  }
}
export const compareResumeObjects = (r1, r2) => {
   const rr1 = JSON.parse( JSON.stringify(r1) )
   const rr2 = JSON.parse( JSON.stringify(r2) )
  delete rr1['modified_date']
  delete rr2['modified_date']
  return JSON.stringify(rr1) === JSON.stringify(rr2);
}